exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-form-textarea[data-v-29e2f67b]{position:relative;border:none;height:auto;max-width:100%}.vc-form-textarea textarea[data-v-29e2f67b]{width:100%;height:100%;max-width:100%;min-width:100%;min-height:80px;max-height:240px;padding:5px;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;outline:none;border:1px solid #999}.vc-form-textarea textarea[data-v-29e2f67b]:focus,.vc-form-textarea textarea[data-v-29e2f67b]:hover{border-color:#39f}.vc-form-textarea[data-v-29e2f67b]:after{content:\"0/100\";position:absolute;top:0;right:7px;font-size:12px}", ""]);

// exports
